import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { useSeo } from "../components/site/Layout";
import { PageHero, Section, CtaBand } from "../components/site/blocks";
import { api } from "../lib/api";

export const formatDate = (iso) => new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export default function Ressources() {
  useSeo("Ressources & guides", "Guides pratiques Habitalys : MaPrimeAdapt', plafonds Anah 2026, douche de plain-pied, MaPrimeRénov' 2026, prévention des chutes.");
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/articles").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <>
      <PageHero eyebrow="Ressources" title="Guides et conseils pour votre projet" intro="Des articles rédigés pour vous aider à comprendre les aides, préparer vos travaux et sécuriser votre logement." />
      <Section testid="articles-list">
        {!items && <p className="text-slate-600">Chargement des articles…</p>}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items?.map((a) => (
            <Link key={a.slug} to={`/ressources/${a.slug}`} data-testid={`article-card-${a.slug}`} className="group rounded-2xl overflow-hidden border border-navy/10 bg-white hover:shadow-[0_30px_60px_-35px_rgba(16,36,62,0.5)] transition-shadow flex flex-col">
              <div className="overflow-hidden"><img src={a.image} alt="" loading="lazy" className="w-full aspect-[16/10] object-cover group-hover:scale-[1.03] transition-transform duration-500" /></div>
              <div className="p-6 flex flex-col flex-1">
                <p className="eyebrow">{a.category}</p>
                <h2 className="mt-3 text-xl sm:text-2xl leading-snug">{a.title}</h2>
                <p className="mt-3 text-slate-700 text-[15px] flex-1">{a.excerpt}</p>
                <p className="mt-5 flex items-center justify-between text-sm text-slate-600">
                  <span className="inline-flex items-center gap-1"><Clock className="h-4 w-4" aria-hidden="true" /> {a.reading_time} min · {formatDate(a.published_at)}</span>
                  <ArrowRight className="h-5 w-5 text-brand-ink group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                </p>
              </div>
            </Link>
          ))}
        </div>
      </Section>
      <CtaBand />
    </>
  );
}
